module.exports = __webpack_public_path__ + "img/scroll-bg-1.fffb667d.png";